<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 16 16">
    <path d="M11.511 7.503v-1.698l-2.424 2.421 2.412 2.431 0.011-1.677h3.482v-1.479h-3.482zM7 14.5h1.5v-12.5h-1.5v12.5zM4.020 7.503h-3.513v1.478h3.513l-0.019 1.677 2.412-2.431-2.393-2.421v1.698z"></path>
</svg>
    


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-column-resize.html